module.exports = __webpack_public_path__ + "static/media/chrome-logo.100777e1.png";